const TIME = {
  SUCCESS_ROUTER_CHANGE: 1000 * 2,
};

export default TIME;
